module.exports = __webpack_public_path__ + "static/img/12.f6a592d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/12.png
// module id = knXU
// module chunks = 0